export type OfferId = 'kit' | 'megapack'

export type Offer = {
  id: OfferId
  name: string
  shortName: string
  description: string
  price: string
  originalPrice: string
  checkoutUrl: string
  badge?: string
}

export const offers: Record<OfferId, Offer> = {
  kit: {
    id: 'kit',
    name: 'Kit de Colorimetría PRO',
    shortName: 'Kit PRO',
    description: '6 tomos + 6 bonos',
    price: '$19.990',
    originalPrice: '$29.990',
    checkoutUrl: 'https://checkout.academiademaquilladores.shop/cart/48836078600362:1',
  },
  megapack: {
    id: 'megapack',
    name: 'Megapack de Colorimetría PRO',
    shortName: 'Megapack PRO',
    description: '8 tomos + 6 bonos + Eventos',
    price: '$29.990',
    originalPrice: '$44.990',
    checkoutUrl: 'https://checkout.academiademaquilladores.shop/cart/48836079419562:1',
    badge: '⭐ Más elegido',
  },
}

